import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC } from 'react';
import { PersonalTabs } from '../../../consts/types/user';
import PersonalDetails from '../PersonalDetails';
const { NotificationManager } = require('react-notifications');

interface EditPersonalDialogProps {
    isOpen: boolean;
    onClose: () => void;
    tab: PersonalTabs;
}

type Props = EditPersonalDialogProps;


const EditPersonalDialog: FC<Props> = (props: Props) => {
    const { isOpen, onClose, tab } = props;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    return <Dialog fullScreen={fullScreen} fullWidth onClose={() => { onClose() }} open={isOpen}>
        <DialogTitle>Edit Personal Information</DialogTitle>
        <Box px={2} minWidth="30%">
            <PersonalDetails currentTab={tab} onClose={onClose}/>
            <Stack spacing={3}>
                {/* <TextField size="small" type="text" value={newSocial.link} onChange={e => setNewSocial({ ...newSocial, link: e.target.value })} label="Link" fullWidth required /> */}

            </Stack>
            <Box display="flex" justifyContent="center" my={3}>
                {/* <Button onClick={() => { clearSocial(); setIsAddingSocial(false); }} color="inherit" sx={{ mr: 2 }}>Cancel</Button>
                <Button variant="contained" onClick={addNewSocial} disabled={isSavingSocial}>Submit</Button> */}
            </Box>
        </Box>
    </Dialog>;
}


export default EditPersonalDialog;

